import {
    useCallback,
    useRef,
    useState,
} from "react"

import { useBoolean } from "react-use"

import { PropTypes } from "@l2r-front/l2r-proptypes"

import { DrawControl } from "./DrawControl"

export const Draw = (props) => {
    const {
        container,
        defaultMode,
        modesConfig,
        lineColorStyle,
        opts,
        onFeaturesChange,
    } = props

    const [drawMode, setDrawMode] = useState(defaultMode)
    const [isDirty, setIsDirty] = useBoolean(false)
    const drawRef = useRef(null)

    const handleChangeMode = useCallback((newMode, newModeOpts) => {
        if (newMode) {
            const currentFeatures = drawRef.current.getAll().features
            setDrawMode(newMode)
            drawRef.current?.changeMode(newMode, { drawFeatures: currentFeatures, hasBeenUpdated: isDirty, ...opts, ...newModeOpts })
        }
    }, [setDrawMode, drawRef, isDirty, opts])

    const handleRestore = useCallback(() => {
        drawRef.current?.deleteAll()
        drawRef.current?.trash()
        setIsDirty(false)
        onFeaturesChange(drawRef.current.getAll())
    }, [drawRef, setIsDirty, onFeaturesChange])

    const onAdded = useCallback(() => {
        handleChangeMode(defaultMode, { brush: modesConfig[defaultMode].brushes[0] })
        onFeaturesChange(drawRef.current.getAll())
    }, [handleChangeMode, modesConfig, defaultMode, onFeaturesChange])

    const onUpdate = useCallback(
        () => {
            onFeaturesChange(drawRef.current.getAll())
            setIsDirty(true)
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [drawRef])

    if (!container) {
        return null
    }

    return (
        <DrawControl
            container={container}
            ref={drawRef}
            displayControlsDefault={false}
            defaultMode={defaultMode}
            currentMode={drawMode}
            modes={modesConfig}
            lineColorStyle={lineColorStyle}
            isDirty={isDirty}
            onAdded={onAdded}
            onUpdate={onUpdate}
            onModeChange={handleChangeMode}
            onRestore={handleRestore}
        />
    )
}

Draw.propTypes = {
    opts: PropTypes.object.isRequired,
    onFeaturesChange: PropTypes.func.isRequired,
    container: PropTypes.instanceOf(HTMLElement),
}
